module.exports = __webpack_public_path__ + "media/src/images/favicons/favicon-96x96-be9f8d77aeb1a239f7b7fb4bd76c0d14.png";